import parse from 'date-fns/parse';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import timeZoneData from './timezones.json';

export const defaultTimeSlot = [
  {
    day: 0,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 1,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 2,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 3,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 4,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 5,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
  {
    day: 6,
    to: '',
    from: '',
    valid: false,
    openAllDay: false,
    breakFrom: '',
    breakTo: '',
    hasBreak: false,
  },
];

export const generateTimeSlots = (step = 15) => {
  /*
    Generates a list of time strings from 00:00 to the next 24 hours. Each new string
     will be generated by adding `step` minutes to the previous one.
    The list is generated by starting with a random day and adding step minutes till end of the same day.
    Always includes 23:59 as the final slot to complete the day.
  */
  const date = new Date(1970, 1, 1);
  const slots = [];
  while (date.getDate() === 1) {
    slots.push(
      date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    );
    date.setMinutes(date.getMinutes() + step);
  }

  // Always add 23:59 as the final slot if it's not already included
  const lastSlot = '23:59';
  if (!slots.includes(lastSlot)) {
    slots.push(lastSlot);
  }

  return slots;
};

export const getTime = (hour, minute) => {
  const parsedHour = hour < 10 ? `0${hour}` : `${hour}`;
  const parsedMinute = minute < 10 ? `0${minute}` : `${minute}`;
  return `${parsedHour}:${parsedMinute}`;
};

export const timeSlotParse = timeSlots => {
  return timeSlots.map(slot => {
    const {
      day_of_week: day,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      closed_all_day: closedAllDay,
      open_all_day: openAllDay,
      break_start_hour: breakStartHour,
      break_start_minutes: breakStartMinutes,
      break_end_hour: breakEndHour,
      break_end_minutes: breakEndMinutes,
    } = slot;
    const from = closedAllDay ? '' : getTime(openHour, openMinutes);
    const to = closedAllDay ? '' : getTime(closeHour, closeMinutes);
    const hasBreak =
      !closedAllDay &&
      breakStartHour !== null &&
      breakStartHour !== undefined &&
      breakEndHour !== null &&
      breakEndHour !== undefined;
    const breakFrom = hasBreak
      ? getTime(breakStartHour, breakStartMinutes)
      : '';
    const breakTo = hasBreak ? getTime(breakEndHour, breakEndMinutes) : '';

    return {
      day,
      to,
      from,
      valid: !closedAllDay,
      hasBreak,
      breakFrom,
      breakTo,
      openAllDay,
    };
  });
};

export const timeSlotTransform = timeSlots => {
  return timeSlots.map(slot => {
    const closed = slot.openAllDay ? false : !(slot.to && slot.from);
    const openAllDay = slot.openAllDay;
    const hasBreak =
      slot.hasBreak && !slot.openAllDay && slot.breakFrom && slot.breakTo;
    let fromDate = '';
    let toDate = '';
    let openHour = '';
    let openMinutes = '';
    let closeHour = '';
    let closeMinutes = '';
    let breakStartHour = null;
    let breakStartMinutes = null;
    let breakEndHour = null;
    let breakEndMinutes = null;

    if (!closed) {
      fromDate = parse(slot.from, 'HH:mm', new Date());
      toDate = parse(slot.to, 'HH:mm', new Date());
      openHour = getHours(fromDate);
      openMinutes = getMinutes(fromDate);
      closeHour = getHours(toDate);
      closeMinutes = getMinutes(toDate);
    }

    if (hasBreak) {
      const breakFromDate = parse(slot.breakFrom, 'HH:mm', new Date());
      const breakToDate = parse(slot.breakTo, 'HH:mm', new Date());
      breakStartHour = getHours(breakFromDate);
      breakStartMinutes = getMinutes(breakFromDate);
      breakEndHour = getHours(breakToDate);
      breakEndMinutes = getMinutes(breakToDate);
    }

    return {
      day_of_week: slot.day,
      closed_all_day: closed,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      open_all_day: openAllDay,
      break_start_hour: hasBreak ? breakStartHour : null,
      break_start_minutes: hasBreak ? breakStartMinutes : null,
      break_end_hour: hasBreak ? breakEndHour : null,
      break_end_minutes: hasBreak ? breakEndMinutes : null,
    };
  });
};

export const timeZoneOptions = () => {
  return Object.keys(timeZoneData).map(key => ({
    label: key,
    value: timeZoneData[key],
  }));
};
